/* eslint-disable @typescript-eslint/no-non-null-assertion */
import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  useTheme,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Avatar,
  TextField,
  Card,
  Container,
} from "@mui/material";
import { LoadingButton as Button } from "@mui/lab";
import { useNavigate, useParams } from "react-router-dom";
import Store from "@/store";
import { OrderStore } from "@/store/orders";
import { inject, observer } from "mobx-react";
import { IOrder, IVWPost } from "@/interfaces";
import { enqueueSnackbar } from "notistack";

import Details from "@/components/Order/Details";
import Chat from "@/components/Chat";
import { UserStore } from "@/store/user";
import { ChatOrderStore } from "@/store/chat_orders";
import { ORDER_STATUS } from "@/@types/EnumType";
import MarketContractStore from "@/store/contract";
import { useAccount } from "wagmi";
import { formatedBigNumber, stringAvatar } from "@/utility";
import { TradingStore } from "@/store/Trading";
import AppealStore from "@/store/appeal";
import { autorun } from "mobx";
import IDialog from "@/@types/Dialog";
import IChatOrder from "@/interfaces/chatOrder";
import { BigNumber, ethers } from "ethers";
import CommonStore, { UI_ACTION_STATE } from "@/store/common";
import { CanOrderBeCancel, CanUserCancelOrder } from "@/utility/order";
import * as BN from "bignumber.js";

enum ACTION {
  COMPLETE_RELEASE = "Complete, release the token",
  TRANSFERRED_NEXT = "Transferred, next",
  BACK = "Back",
}

const ChatPage = inject(
  Store.type.orderStore,
  Store.type.userStore,
  Store.type.chatOrderStore,
  Store.type.contractStore,
  Store.type.tradingStore,
  Store.type.appealStore,
  Store.type.commonStore,
)(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  observer((props: any) => {
    const userStore = props[Store.type.userStore] as UserStore;
    const orderStore = props[Store.type.orderStore] as OrderStore;
    const chatOrderStore = props[Store.type.chatOrderStore] as ChatOrderStore;
    const commonStore = props[Store.type.commonStore] as CommonStore;
    const contractStore = props[
      Store.type.contractStore
    ] as MarketContractStore;
    const tradingStore = props[Store.type.tradingStore] as TradingStore;
    const appealStore = props[Store.type.appealStore] as AppealStore;

    const [confirmDialog, setConfirmDialog] = useState<IDialog | null>(null);

    const theme = useTheme();
    const navigate = useNavigate();
    const { orderId } = useParams();

    const [side, setSide] = useState<"BUYER" | "SELLER" | null>(null);

    const [otherId, setOtherId] = useState("");
    const [selectedOrder, setSelectedOrder] = useState<IOrder | null>(null);
    const [selectedPost, setSelectedPost] = useState<IVWPost | null>(null);
    const [isSubmiting, setIsSubmiting] = useState<boolean>(false);
    const [action, setAction] = useState<ACTION>(ACTION.TRANSFERRED_NEXT);
    const [appealReason, setAppealReason] = useState<string>("");
    const [appealReasonError, setAppealReasonError] = useState<string>("");
    const { address } = useAccount();
    const [chatOrderMessages, setChatOrderMessages] = useState<
      IChatOrder[] | null
    >(null);
    const [iHaveAppeal, setIHaveAppeal] = useState<boolean | null>(null);

    useEffect(() => {
      let unsubscribeSelectedOrder: (() => void) | null = null;
      (async () => {
        if (orderId) {
          if (!unsubscribeSelectedOrder) {
            unsubscribeSelectedOrder = await orderStore.subscribeToOrder(
              orderId,
            );
          }
        }
      })();
      return () => {
        if (unsubscribeSelectedOrder) {
          unsubscribeSelectedOrder();
          unsubscribeSelectedOrder = null;
        }
      };
    }, [orderId]);

    useEffect(() => {
      let unsubscribeSelectedPost: (() => void) | null = null;
      const disposeAutorun = autorun(async () => {
        const order = orderStore.selectedOrder;
        if (order && userStore.userId) {
          setSelectedOrder(order);
          if (!unsubscribeSelectedPost) {
            unsubscribeSelectedPost = await tradingStore.subscribeToPost(
              order.post_id,
            );
          }
          setSide(order.buyer_id === userStore.userId ? "BUYER" : "SELLER");

          if (order.buyer_id === userStore.userId) {
            // buyer
            switch (order.status) {
              case ORDER_STATUS.OPEN:
                setAction(ACTION.TRANSFERRED_NEXT);
                break;
              default:
                setAction(ACTION.BACK);
                break;
            }
          } else {
            // seller
            switch (order.status) {
              case ORDER_STATUS.OPEN:
              case ORDER_STATUS.PAID:
                setAction(ACTION.COMPLETE_RELEASE);
                break;
              default:
                setAction(ACTION.BACK);
                break;
            }
          }
        } else if (order === null) {
          navigate("/");
          enqueueSnackbar("You do not have permission to view this order.", {
            variant: "error",
          });
        }
      });
      return () => {
        disposeAutorun();
        if (unsubscribeSelectedPost) {
          unsubscribeSelectedPost();
          unsubscribeSelectedPost = null;
        }
      };
    }, [orderStore, userStore]);

    useEffect(() => {
      const disposeAutorun = autorun(() => {
        if (tradingStore.selectedPost) {
          setSelectedPost(tradingStore.selectedPost);
        }
      });
      return () => {
        disposeAutorun();
      };
    }, [tradingStore]);

    const firstItem = 1430;
    const secondItem = 490;
    const ratio = firstItem / (secondItem + firstItem);
    const totalColumns = 12;
    const firstItemColumns = Math.ceil(totalColumns * ratio);
    const secondItemColumns = totalColumns - firstItemColumns;

    const [order_details, setOrder_details] = useState<{
      "Order Number": { value: string };
      // "Order id": { value: string };
      Token: { value: string };
      Quantity: { value: string };
      Price: { value: string };
      Currency: { value: string };
      Payment: { value: string };
      "Total Amount": { value: string };
      "Used address"?: { value: string | undefined };
    } | null>(null);
    const [payment_details, setPayment_details] = useState<{
      [key: string]: { value: string | undefined; isImage?: boolean };
    }>({});
    useEffect(() => {
      let unsubscribeToOrderMessages: (() => void) | null = null;
      if (selectedOrder && selectedPost) {
        (async () => {
          if (selectedOrder.order_id && chatOrderStore) {
            unsubscribeToOrderMessages =
              await chatOrderStore.subscribeToOrderMessages(
                selectedOrder.order_id,
              );
          }
        })();
        let totalAmount = BigNumber.from(selectedOrder.order_amount)
          .mul(BigNumber.from(selectedOrder.price))
          .div(BigNumber.from(10).pow(18));
        const totalAmount2 = BN.BigNumber(totalAmount.toString()).div(
          BN.BigNumber(10).pow(18),
        );

        if (
          BigNumber.from(selectedPost.min_amount).gt(totalAmount) &&
          BigNumber.from(selectedPost.min_amount)
            .sub(totalAmount)
            .eq(ethers.utils.parseUnits("1", "wei"))
        ) {
          totalAmount = BigNumber.from(selectedPost.min_amount);
        }
        setOrder_details({
          "Order Number": { value: selectedOrder.order_number || "" },

          Token: { value: selectedOrder.asset.name },
          Quantity: {
            value: `${formatedBigNumber(selectedOrder.order_amount)} ${
              selectedOrder.asset.symbol
            }`,
          },
          Price: {
            value: `${formatedBigNumber(selectedOrder.price)} ${
              selectedOrder.currency
            }`,
          },
          Currency: { value: selectedOrder.currency },
          Payment: { value: selectedOrder.payment.payment_method.payment_name },
          "Total Amount": {
            value: `${totalAmount2} ${selectedOrder.currency}`,
          },
          "Used address": {
            value: selectedOrder.user?.wallet_address || "",
          },
        });

        let paymentDetails: {
          [key: string]: { value: string | undefined; isImage?: boolean };
        } = {};
        if (side === "BUYER") {
          paymentDetails = selectedOrder.payment.payment_attributes.reduce(
            (
              acc: {
                [key: string]: { value: string; isImage?: boolean };
              },
              attr,
            ) => {
              const attrName = attr.payment_method_attribute.attribute_label;

              if (attrName) {
                if (attr.payment_method_attribute.is_image) {
                  acc[attrName] = {
                    value: attr.attribute_value,
                    isImage: true,
                  };
                } else {
                  acc[attrName] = { value: attr.attribute_value };
                }
              }

              return acc;
            },
            {},
          );
          paymentDetails["Seller address"] = {
            value:
              selectedOrder.order_type == "BUY"
                ? selectedOrder.buyer_address
                : selectedOrder.seller_address,
          };
        } else {
          paymentDetails = {
            "Buyer Address": {
              value:
                selectedPost.post_type === "BUY"
                  ? selectedPost.address
                  : selectedOrder.address,
            },
          };
        }
        if (userStore.userId === selectedOrder.buyer_id) {
          const orderAmount = ethers.utils.parseEther(
            BN.BigNumber(selectedOrder.order_amount)
              .multipliedBy(BN.BigNumber(selectedOrder.price))
              .dividedBy(BN.BigNumber(10).pow(18))
              .dividedBy(BN.BigNumber(10).pow(18))
              .decimalPlaces(2)
              .toString(),
          );
          paymentDetails["Transfer Amount"] = {
            value: `${formatedBigNumber(orderAmount.toString())} ${
              selectedOrder.currency
            }`,
          };
          paymentDetails["Currency"] = { value: selectedOrder.currency };
        }
        if (userStore.userId === selectedOrder.seller_id) {
          paymentDetails["Transfer Amount"] = {
            value: `${formatedBigNumber(selectedOrder.order_amount)} ${
              selectedOrder.asset.symbol
            }`,
          };
          paymentDetails["Currency"] = { value: selectedOrder.asset.name };
        }

        setPayment_details(paymentDetails);
        setOtherId(
          selectedOrder.buyer_id === userStore.userId
            ? selectedOrder.seller_id
            : selectedOrder.buyer_id,
        );
        if (
          selectedOrder.appeals &&
          selectedOrder.appeals[0] &&
          userStore.userId
        ) {
          setIHaveAppeal(
            selectedOrder.appeals[0].created_by === userStore.userId,
          );
        }
      }
      return () => {
        if (unsubscribeToOrderMessages) {
          unsubscribeToOrderMessages();
          unsubscribeToOrderMessages = null;
        }
      };
    }, [selectedOrder, selectedPost]);

    useEffect(() => {
      const disposeAutorun = autorun(() => {
        if (chatOrderStore) {
          setChatOrderMessages(chatOrderStore.orderMessages);
        }
      });
      return () => {
        disposeAutorun();
      };
    }, [chatOrderStore]);

    const handleAction = async () => {
      if (
        address !== selectedOrder?.buyer_address &&
        address !== selectedOrder?.seller_address
      ) {
        enqueueSnackbar("Please connect the wallet used to place the order.", {
          variant: "error",
        });
        setConfirmDialog(null);
        setIsSubmiting(false);
        return;
      }

      setIsSubmiting(true);
      if (chatOrderStore && userStore?.userId && selectedOrder) {
        let content = "";

        if (action === ACTION.TRANSFERRED_NEXT) {
          content = "Buyer paid the order";
        } else if (action === ACTION.COMPLETE_RELEASE) {
          content = "Seller released the token and completed the order";
        } else {
          setConfirmDialog(null);
          setIsSubmiting(false);
          return;
        }

        setConfirmDialog(null);
        try {
          commonStore.setActionState(
            UI_ACTION_STATE.WALLET_CONFIRMATION_PENDING,
          );
          await contractStore.confirmOrder(
            selectedOrder.contract_order_id!,
            (result) => {
              commonStore.setActionState(result);
            },
          );
          await chatOrderStore.sendMessage(
            selectedOrder.order_id,
            content,
            [userStore.userId, otherId],
            "status",
          );
        } catch (error) {
          console.error(error);
          enqueueSnackbar("Something went wrong, please try again later.", {
            variant: "error",
          });
        } finally {
          commonStore.setActionState(UI_ACTION_STATE.NONE);
        }
      }
      setIsSubmiting(false);
    };

    const handleIGotProblem = async () => {
      setIsSubmiting(true);
      if (
        address !== selectedOrder?.buyer_address &&
        address !== selectedOrder?.seller_address
      ) {
        enqueueSnackbar("Please connect the wallet used to place the order.", {
          variant: "error",
        });
        setConfirmDialog(null);
        setIsSubmiting(false);
        return;
      }
      if (!appealReason) {
        setAppealReasonError("Please enter your appeal reason.");
        setIsSubmiting(false);
        return;
      } else {
        setAppealReasonError("");
      }
      if (
        selectedOrder &&
        userStore?.userId &&
        side &&
        appealReason &&
        selectedOrder.contract_order_id &&
        address
      ) {
        setConfirmDialog(null);
        try {
          const initialData = await contractStore.createMsgAppeal(
            selectedOrder.contract_order_id,
          );
          await appealStore.createAppeal({
            appeal_to: otherId,
            appeal_type: side,
            appeal_reason: appealReason,
            ...initialData,
          });

          // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error: any) {
          enqueueSnackbar(`Failed to create appeal: ${error.message}`, {
            variant: "error",
          });
        }
      }
      setIsSubmiting(false);
    };

    const handleCancel = async () => {
      setIsSubmiting(true);
      setConfirmDialog(null);
      try {
        commonStore.setActionState(UI_ACTION_STATE.WALLET_CONFIRMATION_PENDING);
        await contractStore.cancelOrder(
          selectedOrder!.contract_order_id!,
          (result) => {
            commonStore.setActionState(result);
          },
        );
        const content = "Seller cancelled the order.";
        chatOrderStore.sendMessage(
          selectedOrder?.order_id || "",
          content,
          [userStore?.userId || "", otherId],
          "status",
        );
      } catch (error) {
        console.error(error);
        enqueueSnackbar("Something went wrong, please try again later.", {
          variant: "error",
        });
      }
      commonStore.setActionState(UI_ACTION_STATE.NONE);
      setIsSubmiting(false);
    };
    const disabledAction = () => {
      if (selectedOrder) {
        if (side === "SELLER") {
          return selectedOrder.status === "OPEN";
        }
      }
      return false;
    };
    if (userStore.userId === null) {
      // window.location.href = "/sign-in?redirect=/trade/orders/" + orderId;

      return <></>;
    }

    return (
      <Container
        maxWidth="xl"
        sx={{
          [theme.breakpoints.up("lg")]: { maxWidth: "xl" },
        }}
      >
        <Grid container justifyContent="stretch" alignContent="stretch">
          <Grid item sm={12} md={firstItemColumns}>
            <Box
              pl="75px"
              pr="20px"
              overflow="auto"
              sx={{
                height: {
                  sm: "fit-content",
                  md: `calc(100vh - ${theme.footerHeight} - ${theme.navbarHeight})`,
                },
              }}
            >
              <Box mt="48.7px" mb="26px">
                {selectedPost && (
                  <>
                    <Avatar
                      {...stringAvatar(
                        selectedPost.firstname + " " + selectedPost.lastname ??
                          "",
                        {
                          width: "80px",
                          height: "80px",
                          mb: "41.3px",
                          mx: "auto",
                          fontSize: "32px",
                          fontWeight: "700",
                        },
                      )}
                    ></Avatar>
                    <Details
                      header={selectedPost.title}
                      dataList={{
                        Firstname: { value: selectedPost.firstname },
                        Lastname: { value: selectedPost.lastname },
                        "Phone number": { value: selectedPost.phone_number },
                      }}
                    />
                  </>
                )}
                <Details
                  header="Order details"
                  dataList={order_details ?? {}}
                  sx={{ mt: "48.5px" }}
                />
                <Details
                  header="Payment details"
                  dataList={payment_details ?? {}}
                  sx={{ mt: "43.5px" }}
                />
                <Typography variant="h3" my="25.5px">
                  Term
                </Typography>
                <Card sx={{ py: "27px", px: "44px" }}>
                  <Typography
                    variant="body3"
                    width="100%"
                    sx={{ overflowWrap: "break-word", whiteSpace: "pre-wrap" }}
                  >
                    {selectedOrder?.post.description}
                  </Typography>
                </Card>
              </Box>
              <Card sx={{ py: "37px", mb: "73px" }}>
                <Grid
                  container
                  columnSpacing="69px"
                  rowSpacing="20px"
                  px="11.5063670411985%"
                >
                  <Grid
                    item
                    sm={
                      iHaveAppeal ||
                      (selectedOrder?.status !== ORDER_STATUS.CANCELLED &&
                        selectedOrder?.status !== ORDER_STATUS.CLOSED)
                        ? 6
                        : 12
                    }
                    textAlign="center"
                  >
                    {selectedOrder && (
                      <Button
                        variant="contained"
                        loading={isSubmiting}
                        onClick={() => {
                          let text = { header: "", content: "" };
                          if (action === "Transferred, next") {
                            text = {
                              header: "Paid order",
                              content:
                                "Are you sure you want to mark this order as paid?",
                            };
                          } else if (action === "Complete, release the token") {
                            text = {
                              header: "Release the token",
                              content:
                                "Are you sure you want to release the token and complete the order?",
                            };
                          } else if (action === "Back") {
                            navigate("/trade/my-orders");
                            return;
                          } else {
                            return;
                          }
                          setConfirmDialog({
                            title: text.header,
                            contentText: text.content,
                            yesFunction: () => handleAction(),
                          });
                        }}
                        disabled={disabledAction()}
                        sx={{ width: "100%", maxWidth: "497.32px" }}
                      >
                        {action}
                      </Button>
                    )}
                  </Grid>
                  {(iHaveAppeal ||
                    (selectedOrder?.status !== ORDER_STATUS.CANCELLED &&
                      selectedOrder?.status !== ORDER_STATUS.CLOSED)) && (
                    <Grid item sm={6}>
                      <Button
                        variant="outlined"
                        loading={isSubmiting}
                        onClick={() => {
                          if (iHaveAppeal === false) {
                            enqueueSnackbar(
                              (side === "BUYER" ? "buyer" : "Seller") +
                                " has already created an appeal.",
                              {
                                variant: "error",
                              },
                            );
                          } else if (iHaveAppeal && selectedOrder?.appeals) {
                            navigate(`/appeal/${selectedOrder.appeals[0].id}`);
                          } else {
                            setConfirmDialog({
                              title: "Create appeal",
                              createAppeal: true,
                            });
                          }
                        }}
                        sx={{ width: "100%", maxWidth: "497.32px" }}
                      >
                        {iHaveAppeal ? "Go to appeal" : "I got a problem"}
                      </Button>
                    </Grid>
                  )}
                </Grid>
                {CanUserCancelOrder(selectedOrder, userStore.userId) && (
                  <Box
                    px="11.5063670411985%"
                    mt="29px"
                    width="100%"
                    textAlign="center"
                  >
                    <Typography
                      variant="body3"
                      onClick={() => {
                        if (!CanOrderBeCancel(selectedOrder)) {
                          setConfirmDialog({
                            title: "Cancel order",
                            contentText:
                              "Are you sure you want to cancel this order?",
                            yesFunction: () => handleCancel(),
                          });
                        }
                      }}
                      sx={{
                        lineHeight: "26px",
                        letterSpacing: "0.01em",
                        color: theme.colors.blueDark,
                        opacity: CanOrderBeCancel(selectedOrder) ? "0.5" : "1",
                        "&:hover": {
                          cursor: CanOrderBeCancel(selectedOrder)
                            ? "not-allowed"
                            : "pointer",
                        },
                      }}
                    >
                      Cancel order (1 hour after order is created)
                    </Typography>
                  </Box>
                )}
              </Card>
            </Box>
          </Grid>
          <Grid item sm={12} md={secondItemColumns}>
            {selectedOrder && selectedPost && (
              <Chat
                other={{
                  id: otherId,
                  name:
                    userStore.userId === selectedPost?.created_by
                      ? selectedOrder.user?.firstname +
                          " " +
                          selectedOrder.user?.lastname ?? ""
                      : selectedPost.firstname + " " + selectedPost.lastname ??
                        "",
                }}
                chatMessages={chatOrderMessages}
                sendMessage={chatOrderStore.sendMessage}
                sendMessageId={selectedOrder.order_id}
                closeData={{
                  isClosed:
                    selectedOrder.status === ORDER_STATUS.CLOSED ||
                    selectedOrder.status === ORDER_STATUS.CANCELLED,
                  closeText: `The order is
                    ${
                      selectedOrder.status === ORDER_STATUS.CLOSED
                        ? "completed"
                        : "cancelled"
                    }.`,
                }}
              />
            )}
          </Grid>
        </Grid>
        {confirmDialog && (
          <Dialog open={!!confirmDialog} onClose={() => setConfirmDialog(null)}>
            <DialogTitle variant="h3">{confirmDialog.title}</DialogTitle>
            <DialogContent sx={{ pt: "20px !important" }}>
              {confirmDialog.contentText && (
                <DialogContentText>
                  {confirmDialog.contentText}
                </DialogContentText>
              )}
              {confirmDialog.createAppeal && (
                <TextField
                  variant="outlined"
                  fullWidth
                  label="Appeal reason"
                  type="text"
                  multiline
                  name="appeal_reason"
                  id="appeal_reason"
                  value={appealReason}
                  error={!!appealReasonError}
                  helperText={appealReasonError}
                  onChange={(e) => setAppealReason(e.target.value)}
                />
              )}
            </DialogContent>
            <DialogActions>
              <Button
                variant="outlined"
                loading={isSubmiting}
                onClick={() => setConfirmDialog(null)}
              >
                {confirmDialog.createAppeal ? "Cancel" : "No"}
              </Button>
              <Button
                variant="contained"
                loading={isSubmiting}
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                onClick={(e: any) => {
                  if (confirmDialog.yesFunction) {
                    confirmDialog.yesFunction(e);
                  } else {
                    handleIGotProblem();
                  }
                }}
              >
                {confirmDialog.createAppeal ? "Confirm" : "Yes"}
              </Button>
            </DialogActions>
          </Dialog>
        )}
      </Container>
    );
  }),
);

export default ChatPage;
